module.exports = global["surveylab_sentry_testSentry"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./test-sentry.ts");